import React from 'react';
import { RichText } from 'prismic-reactjs';

export const LiveCollaboration = ({ title, text1, text2, id }: any) => (
  <div
    className={'product-design__live-collaboration live-collaboration'}
    id={id}
  >
    <div className="product-design__live-collaboration-wrapper">
      <div className="product-design__live-collaboration-wrapper-content">
        <h4 className={'live-collaboration__title'}>
          {RichText.asText(title)}
        </h4>
        <p className={'live-collaboration__text live-collaboration__text--1'}>
          {RichText.asText(text1)}
        </p>
        <p className={'live-collaboration__text live-collaboration__text--2'}>
          {RichText.asText(text2)}
        </p>
      </div>
      <div className="product-design__our-design-process-collaboration-timeline-video">
        <video autoPlay loop preload="auto" muted>
          <source src="/videos/how_we_collaborate.mp4" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
);
